import * as ActionType from "./affiliateReels.type";

const initialState = {
  affiliateReels: [],
  totalAffiliateReels: 0,
};

export const affiliateReelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_AFFILIATE_REELS:
      return {
        ...state,
        affiliateReels: action.payload,
        totalAffiliateReels: action.totalReels,
      };
    case ActionType.DELETE_AFFILIATE_REELS:
      return {
        ...state,
        affiliateReels: state.affiliateReels.filter(
          (reel) => reel._id !== action.payload
        ),
      };
    default:
      return state;
  }
};
